import { render, staticRenderFns } from "./login3.vue?vue&type=template&id=fb9624ea&scoped=true&"
import script from "./login3.vue?vue&type=script&lang=js&"
export * from "./login3.vue?vue&type=script&lang=js&"
import style0 from "./login3.vue?vue&type=style&index=0&id=fb9624ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9624ea",
  null
  
)

export default component.exports